export const ANNOUNCEKIT_BAR_HEIGHT_VAR = '--announcekit-bar-height';
export const ANNOUNCEKIT_BAR_HEIGHT_FALLBACK = '40px';
export const ANNOUNCEKIT_BOOSTER_BAR_SELECTOR = '[class*="announcekit-booster"]';

export function ensureAnnouncekitBarHeightFallback(root: HTMLElement = document.documentElement): void {
  const current = getComputedStyle(root).getPropertyValue(ANNOUNCEKIT_BAR_HEIGHT_VAR).trim();

  if (!current) {
    root.style.setProperty(ANNOUNCEKIT_BAR_HEIGHT_VAR, ANNOUNCEKIT_BAR_HEIGHT_FALLBACK);
  }
}
